import { Icon } from 'ui/components/primitives';
import { CustomIcon } from './Tooltip.components.styles';
import type { TooltipIconProps } from './Tooltip.components.d';

export const TooltipIcon = ({ icon = 'info' }: TooltipIconProps) => {
  const customIcon: { [key: string]: React.ReactNode } = {
    discount: <Icon.Discount size="m" />,
    info: <Icon.Info size="s" />,
  };

  return <CustomIcon>{customIcon[icon]}</CustomIcon>;
};
